// extracted by mini-css-extract-plugin
export default {"busy":"BusyIndicator_busy__AlrOL","slidein":"BusyIndicator_slidein__8NPp4","big":"BusyIndicator_big__V1ibb"};